import toArray from '@/scripts/utils/get-elements-array';
import toggleModal from '@/scripts/utils/toggle-modal';
import breakpoints from '@/scripts/utils/_breakpoints';
import _debounce from 'lodash/debounce';
import initCustomSelect from '@/scripts/utils/initCustomSelect';
import initCustomDatepicker, { getDates } from '@/scripts/utils/initCustomDatepicker';
import './bookingMenu.scss';


export default function initBookingMenu() {
  const bookingForms = toArray('[data-role*="booking-form"]');
  bookingForms.forEach((form) => {
    function setDates(datePickers) {
      datePickers.forEach((datePicker) => {
        if (!datePicker.selectedDates.length) {
          datePicker.setDate(getDates(form));
        }
      });
    }

    const datePickers = Array.from(form.querySelectorAll('[data-role*="datepicker"]')).map(el => initCustomDatepicker(el, form));
    const selects = Array.from(form.querySelectorAll('[data-role*="select"]')).map(el => initCustomSelect(el));

    function removePlaceholders() {
      if (window.innerWidth <= breakpoints.lg && form.dataset.type === 'inline') {
        selects.forEach(($select) => {
          if ($select.data('placeholder-removed')) return false;
          $select.find('option').first().remove();
          return $select.data('placeholder-removed', true);
        });
        window.removeEventListener('resize', removePlaceholders);
      }
    }

    removePlaceholders();

    if (form.dataset.type === 'inline') {
      window.addEventListener('resize', _debounce(() => {
        setDates(datePickers);
      }, 50));
      window.addEventListener('resize', removePlaceholders);
    }
  });


  const triggerButtons = toArray('[data-role*="booking-menu-trigger"]');

  triggerButtons.forEach(button => button.addEventListener('click', (e) => {
    e.preventDefault();

    document.documentElement.classList.toggle('booking-menu-opened');

    return toggleModal(
      document.documentElement.classList.contains('booking-menu-opened'),
      '[data-role*="booking-menu-scrolling-container"]',
      document.querySelector('[data-role="booking-menu-animated"]'),
    );
  }));
}



// WEBPACK FOOTER //
// ./scripts/lib/bookingMenu/bookingMenu.js